/* LeParfin : Pack de Noël « La Collection » (section lp-pack-noel).
   Composeur de 5 parfums (doublons permis, rien n'est remplacé en silence), tiroir vivant avec les vrais étuis,
   lignes des six parfums et fiches dépliables, « Composer pour moi », « Vider le tiroir » et « Annuler »,
   barre collante avec mini tiroir, lien pré-composé (?parfums=velora,aelon… ou ?parfums=auto), brouillon en sessionStorage,
   ajout au panier en UN appel /cart/add.js : 5 lignes parfum + la ligne coffret, reliées par la propriété cachée _lp_pack.
   Utilise window.LP (assets/theme.js) : LP.cart.add, LP.toast. Démarre sur [data-lp-pack] seulement.
   V3.14 coffret (Black Month, 24/10/2026) : taille et parfums offerts lus dans la configuration (max, free : 6 dont 3) ;
   état pre / on / post (window.LP_BM, layout/theme.liquid) : avant l'ouverture, on compose mais l'achat est bloqué, et la
   page se recharge toute seule à l'heure d'ouverture ; « Idées de coffret » (data-pk-preset) ; ancien lien ?avec= accepté ;
   brouillon gardé aussi dans le stockage local 14 jours (il survit à la fermeture de l'onglet avant l'ouverture). */
(() => {
  'use strict';

  /* ---------- Logique pure du choix (testable sans navigateur) ---------- */
  const Sel = {
    /* { velora: 2, sevra: 1 } */
    counts(keys) {
      const c = {};
      keys.forEach((k) => { c[k] = (c[k] || 0) + 1; });
      return c;
    },
    /* Parfums dans l'ordre de première apparition. */
    uniq(keys) {
      return keys.filter((k, i) => keys.indexOf(k) === i);
    },
    /* Unités regroupées par parfum. */
    grouped(keys) {
      const out = [];
      Sel.uniq(keys).forEach((k) => keys.forEach((x) => { if (x === k) out.push(k); }));
      return out;
    },
    /* Complète avec des parfums différents, dans l'ordre des préférences (rien n'est retiré). */
    fit(keys, max, prefs) {
      const u = keys.slice(0, max);
      (prefs || []).forEach((k) => { if (u.length < max && u.indexOf(k) === -1) u.push(k); });
      return u;
    },
    /* « Velora ×2, Sevra » */
    summary(keys, capOf) {
      const c = Sel.counts(keys);
      return Sel.uniq(keys).map((k) => (capOf(k) || k) + (c[k] > 1 ? ' ×' + c[k] : '')).join(', ');
    },
    /* Lignes panier : [{ id, quantity }] regroupées par variante. */
    items(keys, variantOf) {
      const out = [];
      keys.forEach((k) => {
        const id = Number(variantOf(k));
        if (!id) return;
        const line = out.find((x) => x.id === id);
        if (line) line.quantity += 1; else out.push({ id, quantity: 1 });
      });
      return out;
    },
    /* Prix du coffret : la remise offre les « free » parfums les moins chers (2 par défaut ; 3 pour le coffret de 6). */
    price(keys, priceOf, unit, max, free) {
      const f = free == null ? 2 : free;
      if (keys.length < max) return unit * (max - f);
      const p = keys.map((k) => Number(priceOf(k)) || unit).sort((a, b) => b - a);
      return p.slice(0, max - f).reduce((a, b) => a + b, 0);
    },
    /* Clés valides d'un lien ?parfums=… (5 au plus, clés inconnues ignorées). */
    parse(str, known, max) {
      return String(str || '').toLowerCase().split(/[,\s]+/).map((k) => k.trim()).filter((k) => known.indexOf(k) > -1).slice(0, max);
    }
  };

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module !== 'undefined' && module.exports) module.exports = { Sel };
    return;
  }

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fill = (tpl, map) => String(tpl || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? map[k] : m));
  const readJSON = (el) => { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };
  const reduced = () => !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  const design = () => !!(window.Shopify && window.Shopify.designMode);
  const money = (cents) => (Math.round(Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' €';
  const rootUrl = () => ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');
  /* V38 : ajoute un texte dont le prix (la valeur de la pochette, ex. « Avec la pochette 9,90 € offerte. ») s'affiche barré,
     comme dans le panier et les lignes de l'offre. Insertion en nœuds de texte, jamais en HTML. */
  const appendStruck = (el, text) => {
    const str = String(text || '').replace(/\s{2,}/g, ' ');
    const m = str.match(/\d+(?:[.,]\d{1,2})?[\s  ]?€/);
    if (!m) { el.appendChild(document.createTextNode(str)); return; }
    el.appendChild(document.createTextNode(str.slice(0, m.index)));
    const sr = document.createElement('span');
    sr.className = 'sr';
    sr.textContent = 'valeur ';
    const st = document.createElement('s');
    st.className = 'lp-pv';
    st.textContent = m[0];
    el.appendChild(sr);
    el.appendChild(st);
    el.appendChild(document.createTextNode(str.slice(m.index + m[0].length)));
  };
  const store = {
    get() {
      try { const v = JSON.parse(window.sessionStorage.getItem('lp-pack-draft') || 'null'); if (Array.isArray(v)) return v; } catch (e) { /* stockage indisponible */ }
      try {
        const l = JSON.parse(window.localStorage.getItem('lp-pack-draft') || 'null');
        if (l && Array.isArray(l.k) && Date.now() - (l.t || 0) < 14 * 864e5) return l.k;
      } catch (e) { /* stockage indisponible */ }
      return null;
    },
    set(v) {
      try { window.sessionStorage.setItem('lp-pack-draft', JSON.stringify(v)); } catch (e) { /* stockage indisponible */ }
      try { window.localStorage.setItem('lp-pack-draft', JSON.stringify({ k: v, t: Date.now() })); } catch (e) { /* stockage indisponible */ }
    }
  };

  function toast(msg) { if (msg && window.LP && typeof LP.toast === 'function') LP.toast(msg); }

  /* Ajout au panier : LP.cart.add (theme.js : transmet les propriétés, ouvre le tiroir), sinon /cart/add.js puis page panier. */
  function addItems(items) {
    if (window.LP && LP.cart && typeof LP.cart.add === 'function') return Promise.resolve(LP.cart.add(items, { open: true }));
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    }).then((r) => {
      if (!r.ok) throw new Error('cart');
      window.location.href = rootUrl() + 'cart';
    });
  }

  /* ---------- Bandeau d'annonce : masquer un message sur cette page (ex. un message qui ne concerne pas le coffret) ---------- */
  function hideAnn(match) {
    if (!match || design()) return;
    const ann = $('.ann');
    if (!ann) return;
    const items = $$(':scope > a', ann);
    const keep = items.filter((a) => a.textContent.indexOf(match) === -1);
    if (!keep.length || keep.length === items.length) return;
    items.forEach((a) => { if (keep.indexOf(a) === -1) a.remove(); });
    if (ann._lpT) { clearInterval(ann._lpT); ann._lpT = 0; }
    keep.forEach((a) => a.classList.remove('on'));
    keep[0].classList.add('on');
    if (keep.length < 2) return;
    const ms = Math.max(1500, Number(ann.dataset.interval) || 4200);
    ann._lpT = setInterval(() => {
      if (ann._lpPause) return;
      const i = keep.findIndex((x) => x.classList.contains('on'));
      keep.forEach((x) => x.classList.remove('on'));
      keep[(i + 1) % keep.length].classList.add('on');
    }, ms);
  }

  /* ---------- Galerie : points sous les photos (mobile) ---------- */
  function initGallery(root) {
    const gal = $('.gal', root);
    const dots = $$('.gal-d i', root);
    if (!gal || dots.length < 2) return;
    let raf = 0;
    const sync = () => {
      raf = 0;
      const figs = gal.children;
      if (!figs.length || !figs[0].offsetWidth) return;
      const step = figs.length > 1 ? (figs[1].offsetLeft - figs[0].offsetLeft) : figs[0].offsetWidth;
      if (!step) return;
      const atEnd = gal.scrollLeft + gal.clientWidth >= gal.scrollWidth - 2;
      const i = atEnd ? dots.length - 1 : Math.min(dots.length - 1, Math.round(gal.scrollLeft / step));
      dots.forEach((d, j) => d.classList.toggle('on', j === i));
    };
    gal.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(sync); }, { passive: true });
  }

  /* ---------- Galerie en ordinateur : elle défile avec la page puis reste à l'écran (bas visible, au-dessus de la barre
     collante) pendant que la colonne d'achat, plus haute, continue. Sans script : galerie normale. ---------- */
  function initStickyGallery(root) {
    const w = $('.gal-w', root);
    if (!w || !window.matchMedia) return;
    const mq = window.matchMedia('(min-width: 1000px)');
    let raf = 0;
    const set = () => {
      raf = 0;
      if (!mq.matches) { w.style.removeProperty('--pk-gal-top'); return; }
      const top = Math.min(96, Math.round(window.innerHeight - w.offsetHeight - 96));
      w.style.setProperty('--pk-gal-top', top + 'px');
    };
    const ask = () => { if (!raf) raf = requestAnimationFrame(set); };
    set();
    window.addEventListener('resize', ask, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(ask).observe(w);
    $$('img', w).forEach((im) => { if (!im.complete) im.addEventListener('load', ask, { once: true }); });
  }

  /* ---------- Vidéo de la galerie : lecture seulement à l'écran ; mouvement réduit : arrêtée, bouton lecture ---------- */
  function initVideos(root) {
    $$('.gal-v', root).forEach((fig) => {
      const v = $('video', fig);
      const btn = $('[data-pk-play]', fig);
      if (!v) return;
      v.muted = true;
      v.setAttribute('playsinline', '');
      if (reduced()) {
        v.removeAttribute('autoplay');
        try { v.pause(); } catch (e) { /* rien */ }
        if (btn) {
          btn.hidden = false;
          btn.addEventListener('click', () => { btn.hidden = true; v.play().catch(() => {}); });
        }
        return;
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((es) => es.forEach((e) => {
          if (e.isIntersecting) v.play().catch(() => {}); else v.pause();
        }), { threshold: 0.2 }).observe(v);
      }
      v.addEventListener('click', () => { if (v.paused) v.play().catch(() => {}); else v.pause(); });
    });
  }

  /* ---------- Le composeur ---------- */
  function init(root) {
    if (!root || root.__pkInit) return;
    const cfg = readJSON($('[data-pk-config]', root));
    if (!cfg) return;
    root.__pkInit = true;

    const t = cfg.t || {};
    const P = cfg.perfumes || {};
    const MAX = cfg.max || 5;
    const FREE = cfg.free == null ? 2 : cfg.free;
    /* État du Black Month : « pre » avant l'ouverture (achat bloqué), « on » pendant, « post » sans en-tête ou après. */
    const BMS = window.LP_BM || null;
    const stateNow = () => {
      if (!cfg.bmShow || cfg.mode === 'off') return 'post';
      if (BMS) { if (BMS.on) return 'on'; return BMS.start && Date.now() < BMS.start ? 'pre' : 'post'; }
      return cfg.state || 'post';
    };
    const state = stateNow();
    root.dataset.pkState = state;
    if (state === 'pre' && BMS && BMS.start && !design()) {
      const wait = BMS.start - Date.now() + 1500;
      if (wait > 0 && wait < 6 * 36e5) setTimeout(() => window.location.reload(), wait);
    }
    const pre = state === 'pre';
    const order = Object.keys(P);
    const capOf = (k) => (P[k] && P[k].cap) || k;
    const okOf = (k) => !!(P[k] && P[k].ok && P[k].id);
    const props = (cfg.proposals || [])
      .map((a) => (Array.isArray(a) ? a.filter((k) => okOf(k)).slice(0, MAX) : []))
      .filter((a) => a.length === MAX);
    if (!props.length) props.push(order.filter(okOf).slice(0, MAX));

    const pick = $('[data-pk-pick]', root);
    const title = $('[data-pk-title]', root);
    const box = $('[data-pk-box]', root);
    const slots = $$('.pk-slot', root);
    const count = $('[data-pk-count]', root);
    const status = $('[data-pk-status]', root);
    const sum = $('[data-pk-sum]', root);
    const hint = $('[data-pk-hint]', root);
    const autoBtn = $('[data-pk-auto]', root);
    const clearBtn = $('[data-pk-clear]', root);
    const undoBtn = $('[data-pk-undo]', root);
    const buy = $('[data-pk-buy]', root);
    const cta = $('[data-pk-cta]', root);
    const after = $('[data-pk-after]', root);
    const rows = $$('[data-pk-row]', root);
    const sticky = $('[data-pk-sticky]', root);
    const stickyP = $('[data-pk-sticky-p]', root);
    const stickyBtn = $('[data-pk-sticky-btn]', root);
    const mini = $$('[data-pk-mini] li', root);
    const priceEls = $$('[data-pk-price]', root);
    const chips = $$('[data-pk-preset]', root);
    const sigOf = (ks) => ks.slice().sort().join(',');

    /* Une seule zone annoncée, regroupée toutes les 400 ms ; le message visible change tout de suite. */
    if (status) status.removeAttribute('aria-live');
    const live = document.createElement('p');
    live.className = 'sr';
    live.setAttribute('aria-live', 'polite');
    if (pick) pick.appendChild(live);
    let sayT = 0;
    let flash = '';
    function say(msg) {
      clearTimeout(sayT);
      sayT = setTimeout(() => { live.textContent = ''; requestAnimationFrame(() => { live.textContent = msg; }); }, 400);
    }

    let units = [];
    let uid = 0;
    let autoIdx = -1;
    let autoSig = '';
    let undoUnits = null;
    let undoT = 0;
    let busy = false;
    let ready = false;

    const keys = () => units.map((x) => x.k);
    const mk = (k) => ({ k, u: ++uid });
    const isAuto = () => !!autoSig && keys().join(',') === autoSig;
    const missingText = (n, many, one) => (n === 1 ? one : fill(many, { n }));

    function statusText(n) {
      if (n === 0) return t.empty;
      if (n < MAX) return missingText(MAX - n, t.many, t.one);
      return t.full;
    }

    function slotHTML(x, i) {
      const p = P[x.k] || {};
      const label = fill(t.slotFull, { n: i + 1, parfum: capOf(x.k) });
      const pic = p.etui
        ? `<img src="${esc(p.etui)}" srcset="${esc(p.etui)} 120w, ${esc(p.etui2 || p.etui)} 240w" sizes="(min-width:1000px) 80px, 54px" alt="" width="120" height="312" decoding="async">`
        : `<span class="pk-fb"><b>${esc(capOf(x.k))}</b></span>`;
      return `<button type="button" class="pk-slot-b" data-uid="${x.u}" data-slot-rm="${i}" aria-label="${esc(label)}">${pic}<span class="pk-x" aria-hidden="true"><svg viewBox="0 0 12 12" focusable="false"><path d="M3 3l6 6M9 3l-6 6"/></svg></span></button>`;
    }

    function render(opts) {
      const o = opts || {};
      const ks = keys();
      const n = ks.length;
      const c = Sel.counts(ks);
      const full = n >= MAX;

      /* Tiroir : chaque étui garde son identité ; ceux qui changent de case glissent (FLIP), les nouveaux entrent. */
      const prev = {};
      slots.forEach((li) => { const b = $('.pk-slot-b', li); if (b) prev[b.dataset.uid] = b.getBoundingClientRect().left; });
      const fresh = [];
      slots.forEach((li, i) => {
        const x = units[i];
        li.classList.toggle('is-next', i === n);
        if (!x) {
          if (li.dataset.p || !$('.pk-num', li)) {
            li.innerHTML = `<span class="pk-num" aria-hidden="true">${i + 1}</span><span class="sr">${esc(fill(t.slotEmpty, { n: i + 1 }))}</span>`;
            delete li.dataset.p;
          }
          return;
        }
        const cur = $('.pk-slot-b', li);
        if (cur && cur.dataset.uid === String(x.u)) {
          cur.dataset.slotRm = String(i);
          cur.setAttribute('aria-label', fill(t.slotFull, { n: i + 1, parfum: capOf(x.k) }));
          return;
        }
        li.dataset.p = x.k;
        li.innerHTML = slotHTML(x, i);
        fresh.push($('.pk-slot-b', li));
      });
      if (!reduced() && ready) {
        let k = 0;
        fresh.forEach((b) => {
          const from = prev[b.dataset.uid];
          if (from == null) {
            if (o.stagger) b.style.animationDelay = (k++ * 70) + 'ms';
            b.classList.add('pk-in');
            return;
          }
          const dx = from - b.getBoundingClientRect().left;
          if (Math.abs(dx) < 1) return;
          b.style.transition = 'none';
          b.style.transform = `translateX(${dx}px)`;
          requestAnimationFrame(() => requestAnimationFrame(() => {
            b.style.transition = 'transform .3s var(--ease-out)';
            b.style.transform = '';
          }));
        });
      }
      if (box) box.classList.toggle('is-full', full);
      if (count) { count.textContent = n + ' / ' + MAX; count.classList.toggle('ok', full); }

      /* Lignes : « Ajouter » ou compteur, plus grisés quand le coffret est plein. */
      rows.forEach((row) => {
        const k = row.dataset.pkRow;
        const q = c[k] || 0;
        row.classList.toggle('on', q > 0);
        const badge = $('[data-pk-badge]', row);
        if (badge) badge.textContent = q ? '×' + q : '';
        const add = $('[data-pk-add]', row);
        const step = $('[data-pk-step]', row);
        const out = $('[data-pk-n]', row);
        const plus = $('[data-pk-plus]', row);
        if (add) { add.hidden = q > 0; add.setAttribute('aria-disabled', full ? 'true' : 'false'); add.classList.toggle('is-off', full); }
        if (step) step.hidden = q === 0;
        if (out) out.textContent = String(q);
        if (plus) plus.setAttribute('aria-disabled', full ? 'true' : 'false');
        const padd = $('[data-pk-padd]', row);
        if (padd) padd.setAttribute('aria-disabled', full ? 'true' : 'false');
      });

      /* Messages, récapitulatif, raccourci, Vider / Annuler */
      if (status) status.textContent = flash || statusText(n);
      flash = '';
      if (sum) {
        sum.hidden = n === 0;
        sum.textContent = n ? Sel.summary(Sel.grouped(ks), capOf) + '.' : '';
        if (n && full && t.gift) appendStruck(sum, ' ' + t.gift);
      }
      const auto = isAuto();
      if (hint) hint.textContent = auto ? (t.hintAuto || t.hint) : t.hint;
      if (autoBtn) {
        autoBtn.hidden = full && !auto;
        autoBtn.textContent = n === 0 ? t.auto0 : (full ? t.autoNext : t.autoSome);
      }
      if (clearBtn) clearBtn.hidden = n === 0 || !!undoUnits;
      if (undoBtn) undoBtn.hidden = !undoUnits;

      /* Bouton principal et prix */
      const price = money(Sel.price(ks, (k) => P[k] && P[k].price, cfg.unit || 2990, MAX, FREE));
      priceEls.forEach((el) => { el.textContent = price; });
      if (buy && !busy) {
        const ok = full && !pre;
        buy.classList.toggle('is-off', !ok);
        buy.setAttribute('aria-disabled', ok ? 'false' : 'true');
        if (cta) cta.textContent = full ? (pre ? (t.ctaPre || t.ctaReady) : t.ctaReady) : (n === 0 ? t.ctaEmpty : missingText(MAX - n, t.ctaMany, t.ctaOne));
      }
      /* Idées de coffret : celle qui correspond au tiroir est cochée. */
      const sig = sigOf(ks);
      chips.forEach((c) => c.setAttribute('aria-pressed', String(!!c.dataset.sig && c.dataset.sig === sig)));

      /* Barre collante */
      if (stickyP) stickyP.textContent = n + ' / ' + MAX + ' · ' + price;
      if (stickyBtn) stickyBtn.textContent = full ? (pre ? (t.stickyPre || t.ctaPre || t.ctaReady) : (t.stickyBuy || t.ctaReady)) : t.stickyCompose;
      mini.forEach((li, i) => {
        const x = units[i];
        if (!x) { li.innerHTML = ''; delete li.dataset.p; return; }
        if (li.dataset.p === x.k && li.firstChild) return;
        const p = P[x.k] || {};
        li.dataset.p = x.k;
        li.innerHTML = p.etui ? `<img src="${esc(p.etui)}" alt="" width="14" height="36" decoding="async">` : '<i></i>';
      });

      if (ready && !design()) store.set(ks);
    }

    function bump(k) {
      const row = rows.find((r) => r.dataset.pkRow === k);
      if (!row) return;
      row.classList.remove('bump');
      void row.offsetWidth;
      row.classList.add('bump');
    }

    function shake() {
      if (!box || reduced()) return;
      box.classList.remove('is-shake');
      void box.offsetWidth;
      box.classList.add('is-shake');
    }

    function endUndo() {
      clearTimeout(undoT);
      undoUnits = null;
    }

    function add(k, fromStep) {
      if (!okOf(k)) return;
      if (units.length >= MAX) {
        shake();
        flash = t.fullMore;
        render();
        say(t.fullMore);
        return;
      }
      endUndo();
      units.push(mk(k));
      bump(k);
      render();
      say(statusText(units.length));
      if (fromStep === 'add') {
        const row = rows.find((r) => r.dataset.pkRow === k);
        const plus = row && $('[data-pk-plus]', row);
        if (plus) plus.focus({ preventScroll: true });
      }
    }

    function removeLast(k) {
      const ks = keys();
      const i = ks.lastIndexOf(k);
      if (i < 0) return;
      endUndo();
      units.splice(i, 1);
      const msg = fill(t.removed, { parfum: capOf(k) });
      flash = msg;
      render();
      say(msg);
      if ((Sel.counts(keys())[k] || 0) === 0) {
        const row = rows.find((r) => r.dataset.pkRow === k);
        const addB = row && $('[data-pk-add]', row);
        if (addB) addB.focus({ preventScroll: true });
      }
    }

    function removeAt(i) {
      const x = units[i];
      if (!x) return;
      endUndo();
      units.splice(i, 1);
      const msg = fill(t.removed, { parfum: capOf(x.k) });
      flash = msg;
      render();
      say(msg);
      const next = slots[i] && $('.pk-slot-b', slots[i]);
      const prevB = slots[i - 1] && $('.pk-slot-b', slots[i - 1]);
      const target = next || prevB || title;
      if (target) target.focus({ preventScroll: true });
    }

    function goComposer() {
      if (!pick) return;
      const top = () => pick.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: top(), behavior: reduced() ? 'auto' : 'smooth' });
      /* Les sections .sec (content-visibility) peuvent déplacer la cible pendant le défilement : on recale. */
      setTimeout(() => {
        if (Math.abs(pick.getBoundingClientRect().top - 80) > 8) window.scrollTo({ top: top(), behavior: 'auto' });
        if (title) title.focus({ preventScroll: true });
      }, reduced() ? 0 : 520);
    }

    function autoFill(fromSticky) {
      const n = units.length;
      let next;
      let complete = false;
      if (n === 0) {
        autoIdx = 0;
        next = props[0].slice();
      } else if (n < MAX) {
        const prefs = props[0].concat(order.filter(okOf));
        next = Sel.fit(keys(), MAX, prefs);
        complete = true;
      } else if (isAuto()) {
        autoIdx = (autoIdx + 1) % props.length;
        next = props[autoIdx].slice();
      } else {
        return;
      }
      endUndo();
      if (complete) {
        next.slice(n).forEach((k) => units.push(mk(k)));
        autoSig = '';
      } else {
        units = next.map(mk);
        autoSig = keys().join(',');
      }
      const list = Sel.summary(keys(), capOf);
      const msg = fill(t.auto, { liste: list });
      flash = msg;
      render({ stagger: true });
      say(String(t.auto || '').indexOf('[liste]') > -1 ? msg : msg + ' ' + list + '.');
      if (fromSticky) goComposer();
    }

    /* Idée de coffret : le tiroir prend ses parfums (complété si l'idée en compte moins). */
    function preset(btn) {
      let next = Sel.parse(btn.dataset.pkPreset, order, MAX).filter(okOf);
      if (!next.length) return;
      if (next.length < MAX) next = Sel.fit(next, MAX, props[0].concat(order.filter(okOf)));
      endUndo();
      units = next.map(mk);
      autoSig = '';
      const list = Sel.summary(Sel.grouped(keys()), capOf);
      const msg = fill(t.preset || t.auto, { nom: btn.textContent.trim(), liste: list });
      flash = msg;
      render({ stagger: true });
      say(msg + ' ' + list + '.');
    }

    function clearAll(withUndo) {
      endUndo();
      if (withUndo && units.length) {
        undoUnits = units.slice();
        undoT = setTimeout(() => { undoUnits = null; render(); }, 5000);
      }
      units = [];
      autoSig = '';
      flash = withUndo ? t.cleared : '';
      render();
      if (withUndo) say(t.cleared);
      if (title) title.focus({ preventScroll: true });
    }

    function undo() {
      if (!undoUnits) return;
      units = undoUnits;
      endUndo();
      render();
      say(statusText(units.length));
      if (title) title.focus({ preventScroll: true });
    }

    function doBuy() {
      const ks = keys();
      if (ks.length < MAX) {
        const msg = statusText(ks.length);
        goComposer();
        say(msg);
        return;
      }
      if (pre) {
        flash = t.preMsg || '';
        render();
        say(t.preMsg || '');
        goComposer();
        return;
      }
      if (busy) return;
      const packId = 'N' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 6).toUpperCase();
      const comp = Sel.summary(Sel.grouped(ks), capOf);
      const live = !!(cfg.box && cfg.box.live && cfg.box.id);
      /* Aperçu (coffret pas encore publié, donc impossible à ajouter) : les parfums portent la composition et la vignette du
         coffret en propriétés cachées, pour que le panier les montre regroupés comme ils le seront. */
      const lineProps = live ? { _lp_pack: packId } : { _lp_pack: packId, _lp_preview: comp, _lp_img: (cfg.box && cfg.box.img) || '' };
      const items = Sel.items(ks, (k) => P[k] && P[k].id).map((x) => ({ id: x.id, quantity: x.quantity, properties: Object.assign({}, lineProps) }));
      if (live) {
        const pr = { _lp_pack: packId };
        pr[t.composition || 'Composition'] = comp;
        items.push({ id: Number(cfg.box.id), quantity: 1, properties: pr });
      }
      busy = true;
      let added = false;
      if (buy) { buy.setAttribute('aria-busy', 'true'); if (cta) cta.textContent = t.busy; }
      if (stickyBtn) stickyBtn.setAttribute('aria-busy', 'true');
      addItems(items)
        .then(() => {
          if (after) after.hidden = false;
          added = true;
        })
        .catch(() => { toast(t.error); })
        .finally(() => {
          busy = false;
          if (buy) buy.removeAttribute('aria-busy');
          if (stickyBtn) stickyBtn.removeAttribute('aria-busy');
          render();
          /* Coffret ajouté : il n'est plus un brouillon (au retour sur la page, le tiroir repart vide). */
          if (added) store.set([]);
        });
    }

    /* Clics */
    root.addEventListener('click', (e) => {
      const el = e.target.closest('[data-pk-add],[data-pk-plus],[data-pk-padd],[data-pk-minus],[data-slot-rm],[data-pk-auto],[data-pk-preset],[data-pk-clear],[data-pk-undo],[data-pk-buy],[data-pk-sticky-btn],[data-pk-again]');
      if (!el || !root.contains(el)) return;
      const row = el.closest('[data-pk-row]');
      const k = row && row.dataset.pkRow;
      const d = el.dataset;
      if (d.pkAdd !== undefined) { add(k, 'add'); return; }
      if (d.pkPlus !== undefined || d.pkPadd !== undefined) { add(k); return; }
      if (d.pkMinus !== undefined) { removeLast(k); return; }
      if (d.slotRm !== undefined) { removeAt(Number(d.slotRm)); return; }
      if (d.pkAuto !== undefined) { autoFill(false); return; }
      if (d.pkPreset !== undefined) { preset(el); return; }
      if (d.pkClear !== undefined) { clearAll(true); return; }
      if (d.pkUndo !== undefined) { undo(); return; }
      if (d.pkBuy !== undefined) { e.preventDefault(); doBuy(); return; }
      if (d.pkStickyBtn !== undefined) {
        if (units.length >= MAX) doBuy(); else goComposer();
        return;
      }
      if (d.pkAgain !== undefined) {
        if (after) after.hidden = true;
        clearAll(false);
        goComposer();
      }
    });

    /* Fiches : une seule ouverte (attribut name, et repli pour les navigateurs qui l'ignorent), barres animées à l'ouverture,
       retour doux en haut de la ligne si elle est sortie de l'écran. */
    $$('[data-pk-more]', root).forEach((det) => {
      det.addEventListener('toggle', () => {
        const pan = $('.pk-pan', det);
        if (det.open) {
          $$('[data-pk-more]', root).forEach((o) => { if (o !== det && o.open) o.open = false; });
          if (pan) pan.classList.add('in');
        }
        const row = det.closest('[data-pk-row]');
        if (row) {
          const top = row.getBoundingClientRect().top;
          if (top < 70) window.scrollTo({ top: top + window.pageYOffset - 84, behavior: reduced() ? 'auto' : 'smooth' });
        }
      });
    });

    /* Barre collante : visible quand ni le tiroir ni le bouton principal ne sont à l'écran, cachée au pied de page. */
    if (sticky && box && 'IntersectionObserver' in window) {
      let boxVis = true;
      let boxAbove = false;
      let ctaVis = false;
      let footVis = false;
      const foot = $('.ftr') || $('footer');
      const upd = () => {
        const on = !boxVis && boxAbove && !ctaVis && !footVis;
        sticky.classList.toggle('on', on);
        document.body.classList.toggle('has-sticky', on);
      };
      const io = new IntersectionObserver((es) => {
        es.forEach((en) => {
          if (en.target === box) { boxVis = en.isIntersecting; boxAbove = !en.isIntersecting && en.boundingClientRect.top < 0; }
          else if (en.target === buy) ctaVis = en.isIntersecting;
          else footVis = en.isIntersecting;
        });
        upd();
      }, { threshold: 0 });
      io.observe(box);
      if (buy) io.observe(buy);
      if (foot) io.observe(foot);
      root.__pkIO = io;
    }

    /* Arrivée : lien pré-composé, sinon brouillon de la session, sinon réglage « pré-rempli », éditeur : 3 parfums. */
    let start = [];
    let fromAuto = false;
    const qs = new URLSearchParams(window.location.search);
    const q = qs.get('parfums') || qs.get('avec');
    chips.forEach((c) => { c.dataset.sig = sigOf(Sel.parse(c.dataset.pkPreset, order, MAX).filter(okOf)); });
    if (q) {
      if (q.trim().toLowerCase() === 'auto') { start = props[0].slice(); fromAuto = true; }
      else start = Sel.parse(q, order, MAX).filter(okOf);
      /* V3.14 compact : coffret pré-rempli ; le lien d'une fiche part de ce parfum et se complète avec les autres. */
      if (cfg.prefill && start.length && start.length < MAX) start = Sel.fit(start, MAX, props[0].concat(order.filter(okOf)));
    } else if (design()) {
      start = props[0].slice(0, 3);
    } else {
      const saved = store.get();
      if (saved && saved.length) start = saved.filter((k) => okOf(k)).slice(0, MAX);
      else if (cfg.prefill) { start = props[0].slice(); fromAuto = true; }
    }
    units = start.map(mk);
    if (fromAuto) { autoIdx = 0; autoSig = keys().join(','); }
    render();
    ready = true;
    if (!design()) store.set(keys());

    /* Préchargement discret des six étuis (petites images) */
    const warm = () => order.forEach((k) => { if (P[k] && P[k].etui) { const im = new Image(); im.src = P[k].etui; } });
    if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 3000 }); else setTimeout(warm, 1500);

    initGallery(root);
    initStickyGallery(root);
    initVideos(root);
    hideAnn(cfg.annHide);
  }

  function boot(scope) { $$('[data-lp-pack]', scope).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);

  /* Éditeur de thème */
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    $$('[data-lp-pack]', e.target).forEach((root) => { if (root.__pkIO) root.__pkIO.disconnect(); });
    document.body.classList.remove('has-sticky');
  });
  document.addEventListener('shopify:block:select', (e) => {
    const d = e.target;
    if (d && d.matches && d.matches('details.lp-ob-i')) d.open = true;
    const row = d && d.closest && d.closest('[data-pk-row]');
    const more = row && $('[data-pk-more]', row);
    if (more) more.open = true;
  });
})();
